import React, { Component } from "react";
import Fade from "react-reveal";

class Footer extends Component {
  scrollToTop = (e) => {
    e.preventDefault();
    // همیشه به بالای صفحه اسکرول کن
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  render() {
    if (!this.props.data) return null;

    const networks = this.props.data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url} target="_blank" rel="noopener noreferrer">
            <i className={network.className} title={network.title}></i>
          </a>
        </li>
      );
    });

    return (
      <footer>
        <div className="row">
          <Fade bottom>
            <div className="twelve columns">
              <ul className="social-links">{networks}</ul>

              <ul className="copyright">
                <li>&copy; 2020-2025 Adak Developers</li>
                <li>
                  Design by{" "}
                  <a rel="noreferrer" href="/" title="Taha">
                    Taha Yazdani
                  </a>
                </li>
              </ul>
            </div>
          </Fade>

          <div id="go-top">
            <a
              className="smoothscroll"
              title="Back to Top"
              href="#top" // فقط این خط تغییر کرد
              onClick={this.scrollToTop}
            >
              <i className="icon-up-open"></i>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
